import React from 'react';
import { Link } from 'react-router-dom';

import Redo from '../App/Redo';
import Banner from '../App/Banner';

import UKPlatform from '../../assets/categories/UKPlatform.png'
import Check from '../../assets/check.svg'
import Arrow from '../../assets/arrow.svg'
import GreyArrow from '../../assets/grey arrow.svg'

function UkWithPlatform() {
  return(

    <div>
      <Banner />
      <div className='paper'>

      <Link to='/PlatformUK'>
          <button className="return">
          <img src={GreyArrow} alt="fleche grise"/>
            Retour
          </button>
      </Link>

      <div className='breadcrumbs'>
          <p><img src={Check} />Votre stock se situe en Union Européenne</p>
          <p><img src={Check} />Vous vendez vers le Royaume-Uni</p>
          <p><img src={Check} />La marchandise est inférieure à 135 £</p>
          <p><img src={Check} />Vous passez par une plateforme facilitatrice</p>
      </div>

      <h4>La procédure :</h4>
      <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />La TVA est déclarée et payée par la plateforme</ul>
      <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />La vente est exonérée de TVA pour vous</ul>
      <hr />

      <div className="categorie">
        <h4>Si vous êtes client Dougs :</h4>
        <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Sélectionnez la catégorie “Ventes de marchandises exonérées”</ul>
        <ul><img src={Arrow} alt="Fleche verte" style={{transform: 'rotate(180deg)'}} />Indiquez la raison “vente hors union européenne”</ul>
        <img src={UKPlatform} style={{padding: '1em'}} alt='categorie PF' />
      </div>

        <div className="button">
          <Redo />
        </div>
      </div>

    </div>

  )
}

export default UkWithPlatform